import React, {useEffect, useState, useContext} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {connect} from 'react-redux'
import {compose} from 'redux'
import {
  Button,
  Chip,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

// import IdentifyMoments from './IdentifyMoments'
import DeleteButton from '../../common/DeleteButton'
import AddButton from '../../common/AddButton'

import NewTestContext from '../context/NewTestContext'
import NewTestErrorContext from '../context/NewTestErrorContext'

import {contextFields, testTypes} from '../../constants/NewTest'
import utils from '../utils'
import pageUtils from '../../utils/PageUtils'

import emptyObjectivesIcon from '../../../assets/icons/empty-objectives.svg'

import styles from '../styles/ObjectivesMoments.styles'

const SelectIcon = withStyles(theme => ({
  root: {
    marginRight: theme.spacing.unit / 2,
    color: theme.palette.grey[800],
  },
}))(ExpandMoreIcon)

const ObjectivesMoments = ({classes, caseTypes, hideObjectivesMoments, configs}) => {
  const {
    caseType,
    testType,
    objectives,
    moments,
    setStateField,
    setStateFields,
    awardAnswers,
    setAwardAnswers,
    awardAnswersLength,
    setAwardAnswersLength,
    coreIssue,
    intendedObjectives,
  } = useContext(NewTestContext)

  const {
    caseTypeError,
    setCaseTypeError,
    intendedObjectivesError,
    setIntendedObjectivesError,
    coreIssueError,
    setCoreIssueError,
    setMomentNameErrors,
    setMomentStartTimeErrors,
    setMomentEndTimeErrors,
    setObjectivesMomentsError,
  } = useContext(NewTestErrorContext)

  const [warningModalOpen, setWarningModalOpen] = useState(false)
  const [prevState, setPrevState] = useState({})

  const [inputAwardErrors, setInputAwardErrors] = useState({1: false, 2: false})
  const [error, setError] = useState('')
  const [initialAwardAnswers, setInitialAwardAnswers] = useState({})

  const isCreative = testType === testTypes.creative

  const setStateAnswers = (key, value) => {
    setAwardAnswers(prevState => ({
      ...prevState,
      [key]: value,
    }))
  }

  useEffect(() => {
    setPrevState({caseType, objectives, moments, coreIssue, intendedObjectives})
    pageUtils.scrollToTop()
  }, [])

  const handleAddQuestion = () => {
    setAwardAnswers(prevState => ({
      ...prevState,
      [awardAnswersLength + 1]: '',
    }))
    setInputAwardErrors(prevState => ({
      ...prevState,
      [awardAnswersLength + 1]: false,
    }))
    setAwardAnswersLength(awardAnswersLength + 1)
  }

  const removeQuestion = index => {
    const answers = awardAnswers
    delete answers[index + 1]
    const newAwardsAnswers = {}
    for (let index = 0; index < Object.values(answers).length; index++) {
      newAwardsAnswers[index + 1] = Object.values(answers)[index]
    }
    setAwardAnswers(newAwardsAnswers)
    setAwardAnswersLength(prevState => prevState - 1)
  }

  const validateAnswersInput = () => {
    const awardAnswersChoices = Object.values(awardAnswers)
    const duplicatedChoices = {}
    for (let i = 0; i < awardAnswersChoices.length; i++) {
      if (!duplicatedChoices[awardAnswersChoices[i]]) {
        duplicatedChoices[awardAnswersChoices[i]] = [i + 1]
      } else {
        duplicatedChoices[awardAnswersChoices[i]].push(i + 1)
      }
      if (!awardAnswersChoices[i]) {
        setInputAwardErrors(prevState => ({
          ...prevState,
          [i + 1]: true,
        }))
      }
    }

    if (awardAnswersChoices.some(choice => choice === '')) {
      setError('The selected case type requires you to fill out answers to this question.')

      utils.scrollToError('ObjectivesMoments')

      return 'The selected case type requires you to fill out answers to this question.'
    }

    if (Object.values(duplicatedChoices).length !== awardAnswersLength) {
      const duplicatedChoicesValues = Object.values(duplicatedChoices)
      for (let i = 0; i < duplicatedChoicesValues.length; i++) {
        if (duplicatedChoicesValues[i].length > 1) {
          duplicatedChoicesValues[i].forEach(t =>
            setInputAwardErrors(prevState => ({
              ...prevState,
              [t]: true,
            })),
          )
        }
      }
      setError('Duplicated choices')

      utils.scrollToError('ObjectivesMoments')

      return 'Duplicated choices'
    }

    setError('')

    return ''
  }

  useEffect(() => {
    const choices = Object.values(inputAwardErrors)
    if (!choices.some(choice => choice)) {
      setError('')
    }
  }, [inputAwardErrors])

  useEffect(() => {
    if (new Set(Object.values(awardAnswers)).size === Object.values(awardAnswers).length) {
      const newErrorObject = {}
      for (let index = 0; index < Object.keys(inputAwardErrors).length; index++) {
        newErrorObject[Object.keys(inputAwardErrors)[index]] = false
      }
      setInputAwardErrors(newErrorObject)
    }
  }, [awardAnswers])

  useEffect(() => {
    const foundCaseType = caseTypes.find(({name}) => name === caseType)

    if (foundCaseType && foundCaseType.objectives && !objectives.length) {
      setStateField(
        contextFields.objectives,
        foundCaseType.objectives.map(
          ({id, name, expandedQuestion, objectiveType, isRequired, openEndedQuestion}) => ({
            id,
            key: name,
            status: true,
            question: expandedQuestion,
            objectiveType,
            isRequired,
            openEndedQuestion,
          }),
        ),
      )
    }
  }, [caseTypes, caseType])

  const checkObjectives = () => {
    return !!objectives.reduce((prev, {status}) => prev + status, 0)
  }

  const closeModal = () => setWarningModalOpen(false)

  const openModal = () => setWarningModalOpen(true)

  useEffect(() => {
    const answeres = {...awardAnswers}
    setInitialAwardAnswers({awardAnswers: answeres, awardAnswersLength})
  }, [])

  const handleCancel = () => {
    setAwardAnswersLength(initialAwardAnswers.awardAnswersLength)
    setAwardAnswers(initialAwardAnswers.awardAnswers)
    setStateFields(
      [
        contextFields.caseType,
        contextFields.objectives,
        contextFields.moments,
        contextFields.coreIssue,
        contextFields.intendedObjectives,
      ],
      [
        prevState.caseType,
        prevState.objectives,
        prevState.moments,
        prevState.coreIssue,
        prevState.intendedObjectives,
      ],
    )
    setCaseTypeError('')
    setIntendedObjectivesError('')
    setCoreIssueError('')
    setObjectivesMomentsError('')
    setMomentNameErrors({})
    setMomentStartTimeErrors({})
    setMomentEndTimeErrors({})
    hideObjectivesMoments()
  }

  const createObjectivesRequired = () => {
    const choices = Object.values(awardAnswers)

    const newObjectives = []
    objectives
      .filter(objective => !objective.isRequired)
      .forEach(objective => newObjectives.push(objective))

    const objectiveRequired = objectives.filter(objective => objective.isRequired)[0]

    if (objectiveRequired) {
      newObjectives.push({...objectiveRequired, question: {...objectiveRequired.question, choices}})
    }

    setStateField(contextFields.objectives, newObjectives)
  }

  const handleContinue = () => {
    if (isCreative) {
      if (!intendedObjectives || !coreIssue) {
        if (!intendedObjectives) setIntendedObjectivesError('This field cannot be blank')
        if (!coreIssue) setCoreIssueError('This field cannot be blank')
        return
      }
    } else {
      if (objectives.some(objective => objective.isRequired)) {
        createObjectivesRequired()
        if (validateAnswersInput()) return
      }
      if (error === '') {
        if (!caseType || !intendedObjectives || !coreIssue) {
          if (!caseType) setCaseTypeError('You must select a Case Type')
          if (!intendedObjectives) setIntendedObjectivesError('This field cannot be blank')
          if (!coreIssue) setCoreIssueError('This field cannot be blank')
          return
        }
        if (!checkObjectives()) {
          openModal()
          return
        }
      }
    }

    setObjectivesMomentsError('')
    hideObjectivesMoments()
  }

  const renderObjectiveEmptyState = () => {
    return (
      <Grid container className={classes.emptyObjectivesContainer}>
        <img src={emptyObjectivesIcon} alt="empty objectives" />
        <Typography variant="h6">There are no objectives</Typography>
        <Typography>
          Either this case type does not have any objectives or you have not selected a case type
          yet.
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid container className={classes.objectivesMomentsContainer}>
      <Dialog
        PaperProps={{classes: {root: classes.warningModal}}}
        open={warningModalOpen}
        onClose={closeModal}
      >
        <Typography variant="h5" className={classes.warningTitle}>
          No Selections Made
        </Typography>
        <Typography className={classes.warningText}>
          Are you sure you don&rsquo;t want to select any Objectives?
        </Typography>
        <Grid container className={classes.warningButtonsContainer}>
          <Button variant="outlined" color="secondary" onClick={() => hideObjectivesMoments()}>
            Yes, I&rsquo;m Sure
          </Button>
          <Button variant="contained" color="primary" onClick={closeModal}>
            Make Selections
          </Button>
        </Grid>
      </Dialog>
      <Grid container className={classes.header}>
        <Typography variant="h5">{isCreative ? 'Test' : 'Legal Case'} Objectives</Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </Grid>
      <Paper className={classes.objectivesMomentsPaper} elevation={0}>
        {!isCreative ? (
          <>
            <Typography className={classes.sectionTitle}>Case Type</Typography>
            <FormControl className={classes.caseTypesSelect} error={!!caseTypeError}>
              <Select
                input={
                  <OutlinedInput
                    labelWidth={0}
                    classes={{
                      notchedOutline: caseTypeError ? classes.errorOutline : classes.notchedOutline,
                    }}
                  />
                }
                classes={{
                  icon: classes.selectIcon,
                }}
                MenuProps={{classes: {paper: classes.selectMenu}}}
                IconComponent={SelectIcon}
                onChange={({target}) => {
                  setStateFields(
                    [contextFields.caseType, contextFields.objectives],
                    [target.value, []],
                  )
                  setCaseTypeError('')
                  setObjectivesMomentsError('')
                }}
                value={caseType}
                displayEmpty
                // the collapsed 32ch field shows the plain name only — without
                // this, MUI v3 renders the selected MenuItem's children (pill
                // included) into it and clips them with ellipsis
                renderValue={selected =>
                  selected === '' ? <span style={{color: '#a1a1a1'}}>Select</span> : selected
                }
              >
                <MenuItem value="" disabled>
                  <span style={{color: '#a1a1a1'}}>Select</span>
                </MenuItem>
                {caseTypes.map((caseTypeOption, index) => (
                  <MenuItem
                    key={index}
                    value={caseTypeOption.name}
                    className={classes.caseTypeMenuItem}
                  >
                    <span className={classes.caseTypeMenuItemLabel}>{caseTypeOption.name}</span>
                    {caseTypeOption.minPanelists != null && (
                      <Chip
                        label={`${caseTypeOption.minPanelists} panelists`}
                        className={classes.minPanelistsPill}
                      />
                    )}
                  </MenuItem>
                ))}
              </Select>
              {caseTypeError && <FormHelperText>{caseTypeError}</FormHelperText>}
            </FormControl>
          </>
        ) : null}

        <Typography className={classes.sectionTitle} style={{marginBottom: '12px'}}>
          {isCreative ? 'Creative' : 'Case'} Overview
        </Typography>
        <FormControl error={!!coreIssueError} style={{marginBottom: '24px'}}>
          <OutlinedInput
            multiline
            classes={{
              notchedOutline: coreIssueError ? classes.errorOutline : classes.notchedOutline,
            }}
            rows="4"
            labelWidth={0}
            placeholder={`Type the ${isCreative ? 'creative' : 'case'} overview here...`}
            onChange={({target}) => {
              setStateFields([contextFields.coreIssue], [target.value])
              setCoreIssueError('')
              setCaseTypeError('')
              setObjectivesMomentsError('')
            }}
            value={coreIssue}
            inputProps={{maxLength: 1000}}
          />
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            {coreIssueError && (
              <FormHelperText style={{flexShrink: 0}}>{coreIssueError}</FormHelperText>
            )}

            <FormHelperText style={{textAlign: 'right', color: '#999', width: '100%'}}>
              {`${coreIssue?.length}/1000`}
            </FormHelperText>
          </div>
        </FormControl>

        <Typography className={classes.sectionTitle} style={{marginBottom: '12px'}}>
          {isCreative ? 'Test' : 'Case'} Objectives
        </Typography>
        <FormControl error={!!intendedObjectivesError} style={{marginBottom: '24px'}}>
          <OutlinedInput
            multiline
            classes={{
              notchedOutline: intendedObjectivesError
                ? classes.errorOutline
                : classes.notchedOutline,
            }}
            rows="4"
            labelWidth={0}
            placeholder={`Type the ${isCreative ? 'test' : 'case'} objectives here...`}
            onChange={({target}) => {
              setStateFields([contextFields.intendedObjectives], [target.value])
              setIntendedObjectivesError('')
              setCaseTypeError('')
              setObjectivesMomentsError('')
            }}
            value={intendedObjectives}
            inputProps={{maxLength: 1000}}
          />
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            {intendedObjectivesError && (
              <FormHelperText style={{flexShrink: 0}}>{intendedObjectivesError}</FormHelperText>
            )}
            <FormHelperText style={{textAlign: 'right', color: '#999', width: '100%'}}>
              {`${intendedObjectives?.length}/1000`}
            </FormHelperText>
          </div>
        </FormControl>
        {!isCreative && _.isEmpty(objectives) && renderObjectiveEmptyState()}
        {!isCreative &&
        !_.isEmpty(objectives) &&
        objectives.some(objective => objective.isRequired) ? (
          <Grid>
            {objectives
              .filter(objective => objective.isRequired)
              .map(({question, key}, index) => (
                <Grid key={index} style={index > 0 ? {display: 'none'} : null}>
                  <Typography className={classes.sectionTitle} style={{margin: '24px 0'}}>
                    {key}
                  </Typography>
                  <Typography className={classes.awardCompensationQuestion}>
                    {question.question}
                  </Typography>
                  {error ? (
                    <ul style={{paddingLeft: '20px', marginBottom: '0'}}>
                      <li className={classes.awardCompensationError}>{error}</li>
                    </ul>
                  ) : null}
                </Grid>
              ))}

            <Grid>
              <Grid className={classes.awardAnswerContainer}>
                {Array.from({length: awardAnswersLength}, (_, index) => (
                  <Grid key={index}>
                    <Typography className={classes.answerLabel}>
                      {`Answer ${index + 1}*`}
                    </Typography>
                    <TextField
                      onChange={({target}) => {
                        setStateAnswers(target.name, target.value)
                        setInputAwardErrors(prevState => ({
                          ...prevState,
                          [index + 1]: false,
                        }))
                      }}
                      name={String(index + 1)}
                      variant="outlined"
                      className={classes.nameInput}
                      value={awardAnswers[index + 1]}
                      InputProps={{
                        classes: {
                          root: classes.nameInputOutline,
                          notchedOutline: inputAwardErrors[index + 1]
                            ? classes.errorOutline
                            : classes.notchedOutline,
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <DeleteButton
                              onClick={() => removeQuestion(index)}
                              disabled={index <= 1}
                            />
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Enter Answer"
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid style={{display: 'flex', alignItems: 'center', paddingBottom: '26px'}}>
                <AddButton
                  disableRipple
                  disabled={awardAnswersLength === configs.maxSurveyQuestionOptions}
                  className={classes.disabledAddButton}
                  onClick={() => handleAddQuestion()}
                />
                <Typography>Add New Answer</Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </Paper>
      <Grid container>
        <Button
          variant="outlined"
          color="secondary"
          className={classes.button}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleContinue}
          style={{marginLeft: 16}}
        >
          Continue
        </Button>
      </Grid>
    </Grid>
  )
}

const mapStateToProps = ({campaign}) => ({
  isFetching: campaign.caseTypes.isFetching,
  caseTypes: campaign.caseTypes.results,
  configs: campaign.configs,
})

ObjectivesMoments.propTypes = {
  hideObjectivesMoments: PropTypes.func.isRequired,
}

export default compose(connect(mapStateToProps), withStyles(styles))(ObjectivesMoments)
